import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";

export const service = async () => {
  const options: object = {
    url: `/Api/Utility/GetNotifications`,
    method: "GET",
  };
  const response = await callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_NOTIFICATIONS, service, mock);
